import { Box, Stack } from '@mui/material';
import { useEffect } from 'react';
import { IncentiveServices } from '../../../Apis/IncentivesService';
import {
  getIncentivesGamificationsState,
  setPolicyDetailsState,
  setPolicyRuleState,
} from '../../../features/IncentivesGamificationsSlice';
import { useSnackbar } from '../../../providers/SnackbarProvider';
import { useAppDispatch, useAppSelector } from '../../../store';
import { IncentivePayoutPolicyType } from '../../../types/incentives';
import {
  IncentivePolicyRulesRequest,
  PolicyRangeProps,
} from '../../../types/request/incentives';
import { getOrdinalNumber } from '../../../utils/DateUtlility';
import { getErrorMessageFromErrorObj } from '../../../utils/api';
import { PlusCircleIcon } from '../../Icons/Icons';
import VegaButton from '../../common/VegaButton';
import VegaText from '../../common/VegaText';
import AddPenalty from './AddPenalty';
import { BucketEnum } from '../../../types/targets';

const penaltyPolicy = {
  parameter: '',
  parameterMin: 0,
  parameterMax: 0,
  parameterMetric: '',
  payoutMetric: '',
  payoutCapMetric: '',
  payoutCapMax: 0,
  payoutValue: 0,
  incentivePayoutPolicyType: IncentivePayoutPolicyType.PENALTY,
};

const PenaltyIncentiveComponent = () => {
  const { policyRuleState, selectedTab } = useAppSelector(
    getIncentivesGamificationsState
  );
  const dispatch = useAppDispatch();
  const { setSnackbar } = useSnackbar();
  const searchParams = new URLSearchParams(window.location.search);
  const idFromURL = searchParams.get('id');

  const isEmptyOrUndefined = (value: any) => {
    return typeof value === 'undefined' || value === null || value === '';
  };

  const isParameterValue = () => {
    const isEmptyValue =
      policyRuleState.penaltyRange.length &&
      policyRuleState?.penaltyRange.some(
        (range: PolicyRangeProps) =>
          isEmptyOrUndefined(range.parameter) ||
          isEmptyOrUndefined(range.parameterMin) ||
          isEmptyOrUndefined(range.parameterMax) ||
          isEmptyOrUndefined(range.parameterMetric) ||
          isEmptyOrUndefined(range.payoutMetric) ||
          isEmptyOrUndefined(range.payoutCapMax) ||
          isEmptyOrUndefined(range.payoutCapMetric) ||
          isEmptyOrUndefined(range.payoutValue)
      );
    return isEmptyValue;
  };

  const disabled = policyRuleState?.penaltyRange && isParameterValue();

  const handlePolicyRule = (
    key: keyof IncentivePolicyRulesRequest,
    value: any
  ) => {
    const policyRuleStateObj = {
      ...policyRuleState,
      [key]: value,
    } as IncentivePolicyRulesRequest;
    dispatch(setPolicyRuleState(policyRuleStateObj));
  };

  const onAddPenaltyIncentive = () => {
    handlePolicyRule('penaltyRange', [
      ...policyRuleState.penaltyRange,
      penaltyPolicy,
    ]);
  };
  const onDeletePenaltyIncentive = (index: number) => {
    const spreadPenaltyPoicy = [...policyRuleState.penaltyRange];
    spreadPenaltyPoicy.splice(index, 1);
    handlePolicyRule('penaltyRange', spreadPenaltyPoicy);
  };

  const onSubmitPolicy = () => {
    if (idFromURL) {
      IncentiveServices.addRulesForPolicy({
        ...policyRuleState,
        bucket: getBucket(),
        incentiveBasePolicyId: idFromURL,
      })
        .then(response => {
          dispatch(setPolicyDetailsState(response));
          setSnackbar('Add penalty incentive successfully !!!');
        })
        .catch(error => {
          setSnackbar(getErrorMessageFromErrorObj(error), 'error');
        });
    } else {
      setSnackbar('No incentive base policy id for this bucket', 'error');
    }
  };

  const getBucket = () => {
    if (selectedTab === 1) {
      return BucketEnum.BUCKET1;
    } else if (selectedTab === 2) {
      return BucketEnum.BUCKET2;
    } else if (selectedTab === 3) {
      return BucketEnum.BUCKET2;
    } else if (selectedTab === 4) {
      return BucketEnum.NPA;
    } else {
      return BucketEnum.BUCKETX;
    }
  };

  useEffect(() => {
    if (!policyRuleState.penaltyRange) {
      handlePolicyRule('penaltyRange', []);
    }
  }, []);
  return (
    <>
      <Stack
        gap={2}
        sx={{
          width: '100%',
          p: '1.5rem',
        }}
      >
        <VegaText text={'Penalty '} fontWeight={600} fontSize={'1.0625rem'} />

        {policyRuleState?.penaltyRange &&
          policyRuleState.penaltyRange.map(
            (penaltyIncentive: PolicyRangeProps, index: number) => (
              <AddPenalty
                key={index}
                index={index}
                penaltyIncentive={penaltyIncentive}
                onDelete={onDeletePenaltyIncentive}
              />
            )
          )}
        <Box>
          <VegaButton
            variant="text"
            text={`Add ${
              policyRuleState?.penaltyRange?.length + 1
            }${getOrdinalNumber(
              policyRuleState?.penaltyRange?.length + 1
            )} parameter`}
            startIcon={<PlusCircleIcon />}
            onClick={onAddPenaltyIncentive}
          />
        </Box>
        <Box textAlign={'end'}>
          <VegaButton
            text={`Save Penalty incentive`}
            onClick={onSubmitPolicy}
            disabled={disabled}
          />
        </Box>
      </Stack>
    </>
  );
};

export default PenaltyIncentiveComponent;
